import * as React from "react";
import { Checkbox, Arrow } from "sb-resp-ui";
import { DropDown } from "../DropdownDesktop";
export class FreeBetDesktop extends React.PureComponent {
    constructor(props) {
        super(props);
        this.checkboxHandler = () => {
            this.props.selectFreeBet(!this.props.checked ? this.selectedFreeBetId : undefined);
        };
        this.changeSelectedFreeBet = (selectionId) => {
            this.selectedFreeBetId = selectionId;
            this.props.selectFreeBet(selectionId);
        };
        this.openDropdown = () => {
            this.setState({ isDropdownOpen: true });
        };
        this.closeDropdown = () => {
            this.setState({ isDropdownOpen: false });
        };
        this.freeBetSectionRef = React.createRef();
        this.selectedFreeBetId = props.selectedFreeBet.id.toString();
        this.state = { isDropdownOpen: false };
    }
    render() {
        const { id, selectedFreeBet, checked, freeBets, useFreeBetPhrase } = this.props;
        return React.createElement("div", { className: "rj-yourbet__freebet-container", ref: this.freeBetSectionRef },
            React.createElement(Checkbox, Object.assign({}, { id, checked, handler: () => this.checkboxHandler(), dataUat: "free-bet-checkbox" })),
            freeBets.length === 1
                ? React.createElement("label", { htmlFor: id, className: "rj-yourbet__freebet-label", "data-uat": "bet-slip-free-bet-dropdown-label" }, `${useFreeBetPhrase} ${selectedFreeBet.text}`)
                : React.createElement("div", { className: "rj-yourbet__free-bet-dropdown-wrapper" },
                    React.createElement("span", { className: "rj-yourbet__free-bet-name", "data-id": selectedFreeBet.id, "data-uat": "bet-slip-free-bet-dropdown-label" }, `${useFreeBetPhrase} ${selectedFreeBet.text}`),
                    React.createElement(Arrow, { direction: this.state.isDropdownOpen ? "up" : "down" }),
                    React.createElement("div", { className: "rj-yourbet__free-bet-dropdown" },
                        React.createElement(DropDown, { id: "yourbet-free-bet-dropdown", showPlaceHolder: false, data: freeBets.map((freeBet) => {
                                return { value: freeBet.id.toString(), label: freeBet.text, selected: selectedFreeBet.id === freeBet.id };
                            }), onChangeCallback: (selectionId) => this.changeSelectedFreeBet(selectionId), onShowOptionsCallback: this.openDropdown, onHideOptionsCallback: this.closeDropdown }))));
    }
}
//# sourceMappingURL=FreeBetDesktop.js.map